import React from 'react'
import APIKeys from 'src/app/APIProduct/APIKeys/APIKeys'
import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { apiKeysRouteProps } from 'src/navigation/routeProps'

const APIKeysAppRoute: AppRoute = {
  id: AppLocation.OrganizationSettingsAPIKeys,
  routeProps: apiKeysRouteProps,
  component: <APIKeys />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Settings },
}
export default APIKeysAppRoute
